import { DEVICE_ID_PATTERN, newDeviceId } from '@wiztime/core';
import { readStorage, writeStorage } from './safeStorage';
import { StorageKey } from './storageKeys';

/**
 * The persisted 8-hex device identifier; created on first use from the platform's secure random
 * source (`newDeviceId`). Without that source it throws: a weak identifier could collide with
 * another device's and make the two devices' timestamps indistinguishable.
 */
export function loadOrCreateDeviceId(): string {
  const stored = readStorage(StorageKey.DeviceId);
  if (stored !== null && DEVICE_ID_PATTERN.test(stored)) return stored;
  const created = newDeviceId();
  writeStorage(StorageKey.DeviceId, created);
  return created;
}
